import { useQuery } from "@tanstack/react-query";
import { courseschedulesApi, ScheduleConflictApi } from "api/courseSchedulesApi";

export const SCHEDULE_CONFLICTS_KEY = (courseId: number) => ["scheduleConflicts", courseId];

/** One line per conflict, e.g. "Trener Anna Trenerka: także „QA Grupa tematów” (kurs „QA…”) 10:00–11:30". */
export const describeConflict = (c: ScheduleConflictApi, currentCourseId?: number) => {
  const who = c.kind === "trainer" ? `Trener ${c.resource}` : `Sala ${c.resource}`;
  const where = c.otherCourseId === currentCourseId ? "w tym kursie" : `w kursie „${c.otherCourseName}”`;
  return `${who}: także „${c.otherName}” ${where}, ${c.timeFrom}–${c.timeTo}`;
};

export const useScheduleConflicts = (courseId: number) => {
  const { data } = useQuery({
    queryKey: SCHEDULE_CONFLICTS_KEY(courseId),
    queryFn: () => courseschedulesApi.fetchConflicts(courseId).then((r) => r.data),
  });
  const byScheduleId = new Map<number, ScheduleConflictApi[]>();
  for (const c of data ?? []) {
    if (c.scheduleId == null) continue;
    byScheduleId.set(c.scheduleId, [...(byScheduleId.get(c.scheduleId) ?? []), c]);
  }
  return { conflicts: data ?? [], byScheduleId };
};
